import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LoginComponent} from './login/login.component';
import {VersionComponent} from './version/version.component';
import {RciErrorComponent} from './rci-error/rci-error.component';
import {FormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AuthenticationTokenInterceptor} from './interceptors/AuthenticationTokenInterceptor';
import {OfferComponent} from './offer/offer.component';
import {HeaderComponent} from './header/header.component';
import {ElvisComponent} from './elvis/elvis.component';
import {AuthGuard} from './authGuard';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        VersionComponent,
        RciErrorComponent,
        OfferComponent,
        HeaderComponent,
        ElvisComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        AppRoutingModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthenticationTokenInterceptor,
            multi: true
        },
        AuthGuard],
    bootstrap: [AppComponent]
})
export class AppModule {
}
